import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import {
  Card,
  Row,
  Col,
  CardBody,
  CardImg,
  Badge,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import image1 from "../../../../assets/orderingSystem/burger.jpeg";
import { useEffect, useState } from "react";
import ProductDetailModal from "./component/ProductDetailModal";
import ProductItemServices from "../../../../services/OrderingServices/ProductItemService";
import restro from "../../../../assets/orderingSystem/restrologo.png";
import SmallScreenProductDetail from "./component/SmallScreenProductDetail";
import useIsMobile from "../../../../Components/Common/MobileScreen";
import CategoryServices from "../../../../services/OrderingServices/CategoryService";
import ItemService from "../../../../services/OrderingServices/ItemService";
import { FreeMode, Scrollbar } from "swiper";
import NumberWithCommas from "../../../../pages/Pages/Starter/NumberWithCommas";

const ProductPage = ({
  setSelectedItem,
  selectedItem,
  setCount,
  setComplimentaryCount,
  count,
  setSelectedAttributes,
  selectedAttributes,
  handleAddToCart,
  setNotes,
  notes,
  isModalOpen,
  setIsModalOpen,
  setComplementary,
  complementary,
  loading,
  toggleOrderSummary,
  setSelectedTable,
  selectedTable,
  orderData,
  setSelectedChildAttributes,
  selectedChildAttributes,
}) => {
  const orderLength = orderData?.[selectedTable?.id]?.items;
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const soundOnOrderPlaced = user?.user?.soundOnOrderPlaced || false;
  const isBackery = user?.user?.shouldShowTable;

  const [categoryData, setCategoryData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(41);
  const [searchedText, setSearchedText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Menu");
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [debouncedFilters, setDebouncedFilters] = useState({
    namesearch: "",
    categoryId: "",
    PriceMin: "",
    PriceMax: "",
  });
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.75);

  // NEW: State to store all categories with products (globally)
  const [allCategoriesWithProducts, setAllCategoriesWithProducts] = useState(
    new Set()
  );

  // Fetch categories
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await CategoryServices.maincategory({
          showInOrder: true,
        });
        setCategoryData(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategory();
  }, []);

  // NEW: Fetch all products once to determine which categories have products
  useEffect(() => {
    const fetchAllCategories = async () => {
      try {
        const response = await ItemService.itemList({
          namesearch: "",
          PriceMin: "",
          PriceMax: "",
          categoryId: "",
          page: 1,
          pageSize: 9999, // Large number to get all products
          fetchHidden: false,
        });

        // Extract unique categories from all non-hidden products
        const categories = new Set(
          response?.items
            ?.filter((item) => !item.isHidden)
            .map((item) => item.categoryName)
            .filter(Boolean)
        );
        setAllCategoriesWithProducts(categories);
      } catch (error) {
        console.error("Error fetching all categories:", error);
      }
    };

    fetchAllCategories();
  }, []);

  // Debounce filter changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilters({
        namesearch: searchedText,
        categoryId: selectedCategory === "All Menu" ? "" : selectedCategory,
        PriceMin: "",
        PriceMax: "",
      });
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchedText, selectedCategory]);

  // Fetch products with server-side pagination and filtering
  useEffect(() => {
    const fetchProduct = async () => {
      setIsProductLoading(true);
      try {
        const response = await ItemService.itemList({
          namesearch: debouncedFilters.namesearch,
          PriceMin: debouncedFilters.PriceMin,
          PriceMax: debouncedFilters.PriceMax,
          categoryId: debouncedFilters.categoryId,
          page: currentPage,
          pageSize: pageSize,
          fetchHidden: false,
        });
        const indexedData = response?.items.map((item, index) => ({
          ...item,
          sn: (currentPage - 1) * pageSize + index + 1,
        }));

        setProductData(indexedData);
        setTotalRows(response?.totalCount || 0);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setIsProductLoading(false);
      }
    };

    fetchProduct();
  }, [currentPage, pageSize, debouncedFilters]);

  // Handle window resize for maxHeight
  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = useIsMobile();

  // Toggle modal for product details
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const playBeep = () => {
    try {
      const audio = new Audio("/beep1.mp3");
      audio.volume = 0.6;
      const playPromise = audio.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch((err) => {
          console.log("Beep playback rejected:", err);
        });
      }
    } catch (err) {
      console.error("Beep sound error:", err);
    }
  };

  // Skeleton Card Component
  const SkeletonCard = () => (
    <Col lg={3} md={6} sm={6} xs={6}>
      <Card className="border-0 h-100 rounded-3 shadow-sm">
        <CardBody className="d-flex flex-column justify-content-between p-3">
          <div className="d-flex justify-content-center mb-2">
            <div className="skeleton skeleton-image" />
          </div>
          <div className="skeleton skeleton-text" />
          <div className="d-flex justify-content-between align-items-center">
            <div className="skeleton skeleton-badge" />
            <div className="skeleton skeleton-price" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );

  // NEW: Filter categories to only show those with products (based on all products, not filtered)
  const filteredCategories =
    categoryData?.items?.filter((item) =>
      allCategoriesWithProducts.has(item.name)
    ) || [];

  return (
    <div className="px-lg-3 px-0">
      {/* Category Swiper */}
      <div className="sticky-top z-2">
        <Swiper
          spaceBetween={12}
          modules={[FreeMode, Scrollbar]}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumBounce: false,
            momentumRatio: 1,
          }}
          grabCursor={true}
          scrollbar={{ draggable: true }}
          breakpoints={{
            320: { slidesPerView: 2 },
            480: { slidesPerView: 2 },
            640: { slidesPerView: 2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 5 },
          }}
          speed={500}
        >
          {/* Always show "All Menu" */}
          <SwiperSlide>
            <Card
              className={`p-1 rounded-3 text-center shadow-sm border ${
                selectedCategory === "All Menu"
                  ? "border-primary"
                  : "border-light-subtle"
              }`}
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedCategory("All Menu")}
            >
              <Row>
                <Col lg={5} md={5} xs={5}>
                  <CardImg
                    src={restro}
                    alt=""
                    className="img-fluid rounded-3 bg-light p-1"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                    }}
                  />
                </Col>
                <Col lg={7} md={7} xs={7}>
                  <div className="text-start h-100 d-flex justify-content-start align-content-center align-items-center">
                    <h6 className="mb-1 text-truncate">All Menu</h6>
                  </div>
                </Col>
              </Row>
            </Card>
          </SwiperSlide>

          {filteredCategories.map((item, index) => (
            <SwiperSlide key={index}>
              <Card
                className={`p-1 rounded-3 text-center shadow-sm border ${
                  selectedCategory === item.id
                    ? "border-primary"
                    : "border-light-subtle"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedCategory(item.id)}
              >
                <Row>
                  <Col lg={5} md={5} xs={5}>
                    <CardImg
                      src={restro}
                      alt=""
                      className="img-fluid rounded-3 bg-light p-1"
                      style={{
                        objectFit: "contain",
                        width: "100%",
                      }}
                    />
                  </Col>
                  <Col lg={7} md={7} xs={7}>
                    <div className="text-start h-100 d-flex justify-content-start align-content-center align-items-center">
                      <h6 className="mb-1 text-wrap">{item.name}</h6>
                    </div>
                  </Col>
                </Row>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Search Input (Sticky on all screens) */}
        <div className="sticky-top bg-light py-2" style={{ zIndex: 1050 }}>
          <Row className="align-items-center mb-0 rounded-top">
            <Col xs={12} lg={4} className="mb-2">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <h4 className="fw-bold mb-0">Menu</h4>
              </div>
            </Col>

            <Col xs={12} md={12} lg={8} className="">
              <div className="d-flex justify-content-between align-content-center align-items-center gap-lg-0 gap-2">
                <div className="position-relative w-100">
                  <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                  <Input
                    type="text"
                    placeholder="Search menu..."
                    value={searchedText}
                    onChange={(e) => setSearchedText(e.target.value)}
                    className="ps-5 py-2 rounded-3 border shadow-sm"
                    style={{ fontSize: "14px" }}
                  />
                  {searchedText && (
                    <i
                      className="ri-close-line position-absolute top-50 end-0 translate-middle-y me-3 text-danger cursor-pointer"
                      onClick={() => setSearchedText("")}
                    ></i>
                  )}
                </div>
                <div className="d-lg-none d-md-none d-flex p-0">
                  <button
                    className="btn btn-topbar btn-soft-success rounded-circle"
                    onClick={toggleOrderSummary}
                  >
                    <i className="ri-shopping-bag-3-line"></i>
                    {orderLength?.length > 0 && (
                      <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                        {orderLength?.length}
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Product Grid */}
        <Row className="gx-3 gy-4 mb-3">
          {isProductLoading ? (
            [...Array(8)].map((_, index) => <SkeletonCard key={index} />)
          ) : productData.length ? (
            productData
              ?.filter((item) => !item.isHidden)
              .map((item, index) => {
                return (
                  <Col key={index} xs={6} sm={6} md={6} lg={4} xl={3}>
                    <Card
                      className="border-0 h-100 rounded-3 shadow-sm position-relative hover-scale cursor-pointer"
                      style={{
                        transition: "transform 0.2s ease-in-out",
                      }}
                    >
                      <CardBody
                        className="d-flex flex-column justify-content-between p-3 cursor-pointer"
                        onClick={() => {
                          handleAddToCart(item, false);
                          {
                            soundOnOrderPlaced && playBeep();
                          }
                        }}
                      >
                        <div className="d-flex justify-content-center mb-2">
                          <img
                            src={item.displayImage?.getCDNUrl() || restro}
                            alt={item.name}
                            className="img-fluid rounded object-fit-contain rounded-4"
                            style={{
                              height: "120px",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                        <h6 className="text-center fw-semibold mb-1 text-truncate">
                          {item.name}
                        </h6>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex flex-column">
                            {item.discountedPrice &&
                            item.discountedPrice < item.price ? (
                              <>
                                <span className="text-muted text-decoration-line-through">
                                  Rs. {item.price.toFixed(0)}
                                </span>
                                <span className="fw-bold text-success">
                                  Rs. {item.discountedPrice.toFixed(0)}
                                </span>
                              </>
                            ) : (
                              <span className="fw-bold text-dark">
                                Rs. <NumberWithCommas number={item.price} />
                              </span>
                            )}
                          </div>

                          <div>
                            {isBackery && (
                              <button
                                className="btn btn-soft-success btn-sm me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleModal(item);
                                }}
                              >
                                <i className="ri-eye-2-line"></i>
                              </button>
                            )}

                            {!selectedTable && (
                              <button
                                className="btn btn-soft-success btn-sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddToCart(item, true);
                                  console.log("TakeAway Icon Pressed");
                                }}
                              >
                                <i className="ri-shopping-bag-line"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })
          ) : (
            <Col xs={12}>
              <div className="text-center py-5 text-muted">
                <i className="ri-emotion-unhappy-line display-4 text-secondary mb-2"></i>
                <h5 className="fw-semibold">No items match your search</h5>
                <p className="small text-muted">
                  Try a different keyword or filter.
                </p>
              </div>
            </Col>
          )}
        </Row>

        {/* Pagination Controls */}
        {totalRows > 0 && !isProductLoading && (
          <Row className="sticky-bottom">
            <Col xs={12} className="d-flex justify-content-center">
              <Pagination color="success">
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    onClick={() => handlePageChange(currentPage - 1)}
                    previous
                  />
                </PaginationItem>

                {(() => {
                  const maxPagesToShow = 5;
                  const half = Math.floor(maxPagesToShow / 2);

                  let startPage = Math.max(currentPage - half, 1);
                  let endPage = startPage + maxPagesToShow - 1;

                  if (endPage > totalPages) {
                    endPage = totalPages;
                    startPage = Math.max(endPage - maxPagesToShow + 1, 1);
                  }

                  const pageNumbers = [];
                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <PaginationItem key={i} active={i === currentPage}>
                        <PaginationLink onClick={() => handlePageChange(i)}>
                          {i}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  }
                  return pageNumbers;
                })()}

                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    onClick={() => handlePageChange(currentPage + 1)}
                    next
                  />
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </div>

      {isMobile ? (
        <SmallScreenProductDetail
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          setCount={setCount}
          setComplimentaryCount={setComplimentaryCount}
          count={count}
          setNotes={setNotes}
          setSelectedAttributes={setSelectedAttributes}
          selectedAttributes={selectedAttributes}
          handleAddToCart={handleAddToCart}
          setComplementary={setComplementary}
          complementary={complementary}
          loading={loading}
          notes={notes}
          setSelectedChildAttributes={setSelectedChildAttributes}
          selectedChildAttributes={selectedChildAttributes}
        />
      ) : (
        <ProductDetailModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          setCount={setCount}
          setComplimentaryCount={setComplimentaryCount}
          count={count}
          setNotes={setNotes}
          setSelectedAttributes={setSelectedAttributes}
          selectedAttributes={selectedAttributes}
          handleAddToCart={handleAddToCart}
          setComplementary={setComplementary}
          complementary={complementary}
          loading={loading}
          notes={notes}
          setSelectedChildAttributes={setSelectedChildAttributes}
          selectedChildAttributes={selectedChildAttributes}
        />
      )}
    </div>
  );
};

export default ProductPage;
